import { influencer } from '@round/api';
import { ExplorePlatform } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';

const PLATFORMS: ExplorePlatform[] = ['tiktok', 'instagram'];

export type PoolAccount = {
    platform: ExplorePlatform;
    accountId: number;
    username: string;
};

export type CreatorPoolMembership = {
    creator: influencer.CreatorSearchResult;
    /** The creator's platform accounts that are currently in the pool. */
    accounts: PoolAccount[];
};

/**
 * Maps each creator to the platform accounts it holds in the pool. Membership is per account, so a
 * creator can have one account in the pool or both. Creators with no account in the pool are dropped —
 * there is nothing to remove for them.
 */
export const getCreatorPoolMemberships = (
    creators: influencer.CreatorSearchResult[],
    poolId: number | null | undefined
): CreatorPoolMembership[] => {
    if (typeof poolId !== 'number') {
        return [];
    }

    return creators
        .map((creator) => ({ creator, accounts: getInPoolAccounts(creator, poolId) }))
        .filter((membership) => membership.accounts.length > 0);
};

const getInPoolAccounts = (creator: influencer.CreatorSearchResult, poolId: number): PoolAccount[] => {
    const accounts: PoolAccount[] = [];

    PLATFORMS.forEach((platform) => {
        // A creator holds at most one account per platform, whatever the array shape suggests.
        const account = creator.platforms?.[platform]?.[0];
        if (!account || !account.pool_ids?.includes(poolId)) {
            return;
        }

        accounts.push({
            platform,
            accountId: account.creatorbase_client_influencer_account_id,
            username: account.platform_username,
        });
    });

    return accounts;
};
